export const NAV = [
  { l: "Home", p: "home" },
  { l: "What We Do", p: "services" },
  { l: "Portfolio", p: "portfolio" },
  { l: "Pricing", p: "pricing" },
  { l: "Case Studies", p: "cases" },
  { l: "About", p: "about" },
  { l: "Contact", p: "contact" },
];
